import { Loader2 } from "lucide-react";

export default function MainLoading() {
  return (
    <div>
      <div className="fixed inset-0 bg-black/50 h-screen w-full z-99 flex items-center justify-center">
        <Loader2 color="white" className="animate-spin" size={60} />
      </div>
    </div>
  );
}
